import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=fb74d5fc&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Gallery.vue?vue&type=style&index=0&id=fb74d5fc&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fb74d5fc",
  "3d1064e6"
  
)

export default component.exports